import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import startCase from 'lodash/startCase';

const isEmptyArray = (value: unknown) => {
  return Array.isArray(value) && value.length === 0;
};

export const isEmpty = (value: unknown): boolean => {
  return (
    value == null || // Checks for undefined and null
    value === '' ||
    isEmptyArray(value) ||
    (typeof value === 'object' &&
      value !== null &&
      Object.keys(value).length === 0)
  );
};

export const formatOptions = (
  options: ({ value: string; label: string } | string)[]
) =>
  typeof options?.[0] === 'string'
    ? options?.map((option) => ({ value: option, label: option }))
    : options;

export const formatValue = (str?: string | number | null | unknown) => {
  if ((isNumber(str) || isString(str)) && !isEmpty(str)) {
    return str;
  }

  return 'N/A';
};

export const formatEnumToOptions = (enumKeys: Record<string, string>) =>
  Object.keys(enumKeys).map((value) => ({
    text: startCase(value),
    value
  }));
